import React from "react";

import { RevealList } from "../motion/Reveal";
import { useT } from "../../i18n";

// Four columns of plain text under a hairline each. No third-party logos:
// borrowing somebody else's mark to imply a relationship is exactly the kind
// of unearned credibility this site avoids.
//
// Dictionary shape: home.stackGroups is [{ label, items }], where items is a
// comma-separated string. Splitting here rather than storing an array keeps
// the strings natural to translate.

export default function StackGrid() {
  const { tBlocks } = useT();
  const groups = tBlocks("home.stackGroups");

  return (
    <RevealList
      className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8"
      items={groups.map((g, i) => ({ key: g.label, ...g, i }))}
      step={70}
    >
      {({ label, items, i }) => (
        <div className="flex flex-col gap-[18px] border-t border-line pt-[22px]">
          <div className="flex items-center gap-2.5">
            <span className="font-mono text-[11.5px] text-fg-muted tabular-nums">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="font-mono text-[17px] tracking-[-0.3px] text-fg">{label}</span>
          </div>
          <ul className="flex flex-col gap-[9px]">
            {items
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
              .map((item) => (
                <li key={item} className="font-body text-[14.5px] leading-[1.5] text-fg-secondary">
                  {item}
                </li>
              ))}
          </ul>
        </div>
      )}
    </RevealList>
  );
}
